import { render, staticRenderFns } from "./AdmissionTypesLegend.vue?vue&type=template&id=1bcea9ff"
import script from "./AdmissionTypesLegend.vue?vue&type=script&lang=js"
export * from "./AdmissionTypesLegend.vue?vue&type=script&lang=js"
import style0 from "./AdmissionTypesLegend.vue?vue&type=style&index=0&id=1bcea9ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports